export enum AppActionTypes {
    MENU_TOGGLE_OPTIONS = "@ui/MENU_TOGGLE_OPTIONS",
    SHOW_PAYMENTS_IN_MENU = "@ui/SHOW_PAYMENTS_IN_MENU",
    TOGGLE_CHAT_DELAY_MODAL = "@ui/TOGGLE_CHAT_DELAY_MODAL",
    TOGGLE_CHAT_IN_MAINTENANCE_MODAL = "@ui/TOGGLE_CHAT_IN_MAINTENANCE_MODAL",
    TOGGLE_OOPS_MODAL = "@ui/TOGGLE_OOPS_MODAL",
    TOGGLE_REQUESTS_NOTIFICATIONS_STATUS = "@ui/TOGGLE_REQUESTS_NOTIFICATIONS_STATUS",
    ToggleNotificationsModal = "@ui/TOGGLE_NOTIFICATIONS_MODAL",
    ToggleDownloadAppModal = "@ui/TOGGLE_DOWNLOAD_APP_MODAL",
    HOME_VISITED = "@ui/HOME_VISITED",
    INSURANCES_VISITED = "@ui/INSURANCES_VISITED",
    WELLBEING_VISITED = "@ui/WELLBEING_VISITED",
    V1_VISITED = "@ui/V1_VISITED",
    UI_LOADING = "@ui/UI_LOADING",
    TOGGLE_VERA_WHATSAPP_MODAL = "@ui/TOGGLE_VERA_WHATSAPP_MODAL",
}
